export default __webpack_public_path__ + "static/media/file-powerpoint.fb441191.png";